
import { defineComponent } from "vue";
import DoctorsList from "@/components/Departments/common/DoctorsListTemplate3.vue";
import { DepartmentPropDataInterface } from "@/ts/interfaces";

export default defineComponent({
  data(): DepartmentPropDataInterface {
    return {
      name: "Obstetrics And Gynaecology Doctors",
      queryName: "Obstetrics And Gynaecology",
      teamName: "Obstetrics And Gynaecology team",
    };
  },
  components: { DoctorsList },
});
